import React, { FC, useContext } from 'react';
import { Formik, FormikProps } from 'formik';
import { Modal } from 'antd';
import { AntForm } from '@core/ui';
import { FormAlert, TextField } from '@core/form';

import { CreatePartnerBoxContext } from '../contexts';
import { useCreatePartnerBox } from '../hooks';
import { CreatePartnerBoxDto } from '../dtos';

const FormikComponent: FC<FormikProps<CreatePartnerBoxDto>> = ({ status, handleSubmit, isSubmitting }) => {
  const { id, onCancel } = useContext(CreatePartnerBoxContext);
  return (
    <Modal width={768} visible={true} onOk={() => handleSubmit()} onCancel={onCancel} confirmLoading={isSubmitting} title={!id ? 'Yeşik əlavə et' : 'Yeşikdə düzəliş et'}>
      <FormAlert $visible={!!status} message={status?.message} />
      <AntForm layout='vertical' component='div' size='large'>
        <TextField name='name' item={{ label: 'Ad' }} input={{ placeholder: 'Yeşiyin adını daxil edin...' }} />
      </AntForm>
    </Modal>
  );
};

export const CreatePartnerBox: FC = () => {
  const { initialValues, onSubmit } = useCreatePartnerBox();

  if (!initialValues) {
    return null;
  }

  return <Formik initialValues={initialValues} onSubmit={onSubmit} enableReinitialize={true} component={FormikComponent} />;
};
